import { create } from 'zustand';

interface UtilsStore {
  howToChat: string;
  expiredPath: string;
  showRobotPc: boolean;
  updateHowToChat: (path: string) => void;
  updateExpiredPath: (path: string) => void;
  updateShowRobotPc: (isExpired: boolean) => void;
}

export const UtilsStore = create<UtilsStore>((set, get) => ({
  howToChat: '',
  expiredPath: '',
  showRobotPc: true,

  updateHowToChat(path: string) {
    set({ howToChat: path });
  },
  updateExpiredPath(path: string) {
    set({ expiredPath: path });
  },
  updateShowRobotPc(flag: boolean) {
    set({ showRobotPc: flag });
  },
}));
